import userService from '@/services/user.service';
import { useQuery } from 'react-query';
import { Outlet, useLocation } from 'react-router-dom';
import Scale from './Scale';
import './style.scss';

const PageLayoutAdmin = () => {
    return (
        <div className="root">
            <div className="l-main l-main-admin">
                <Outlet />
            </div>
        </div>
    );
};

export default PageLayoutAdmin;
